export const UMBRELLA_ORGANIZATIONS_RECEIVED = 'UMBRELLA_ORGANIZATIONS_RECEIVED'
export const UMBRELLA_ORGANIZATIONS_REQUESTED = 'UMBRELLA_ORGANIZATIONS_REQUESTED'
export const USER_ORGANIZATIONS_RECEIVED = 'USER_ORGANIZATIONS_RECEIVED'
export const USER_ORGANIZATIONS_REQUESTED = 'USER_ORGANIZATIONS_REQUESTED'
